import {connect} from "react-redux";
import StockPage from "./StockPage";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ViewActions from "../../actions/ViewActions";

function mapStateToProps(state) {
  return {
    accessibleWarehouseIds: state.getIn(["auth", "accessibleWarehouseIds"]),
  }
}

export default connect(mapStateToProps, {...InventoryApiActions, ...ViewActions})(StockPage);